var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('back-to-top',{attrs:{"bottom":"50px","right":"50px"}},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }